import { Localization } from "@viamap/viamap2-common";
import { openWindow, WindowId } from "src/WindowManager/WindowState";

export type ConfirmForeignDeleteKind = "single" | "bulk";

export function confirmForeignAnnotationDelete(
   dispatch: (action: ReturnType<typeof openWindow>) => void,
   kind: ConfirmForeignDeleteKind,
   savedByName?: string,
): Promise<boolean> {
   const children = kind === "bulk"
      ? Localization.getText("One or more of these annotations were saved by another user. Continue?")
      : savedByName
         ? Localization.getFormattedText(
            "Are you sure you want to delete this annotation, which was saved by {user}?",
            { user: savedByName },
         )
         : Localization.getText("Are you sure you want to delete this annotation, which was saved by another user?");
   return new Promise((resolve) => {
      dispatch(openWindow(WindowId.ConfirmationDialog, {
         header: "Undo saved annotation",
         children,
         submitLabel: "Yes",
         cancelLabel: "No",
         onSubmit: () => resolve(true),
         onCancel: () => resolve(false),
      }));
   });
}
